module.exports = __webpack_public_path__ + "img/Group 23.5f509140.png";